import React from 'react';
import { MatchPlayerVm } from '../../../../utils/api';

interface CapGridProps {
    players: MatchPlayerVm[];
    side: 'home' | 'away';
    onPick: (player: MatchPlayerVm) => void;
}

/** Rostered caps as round buttons (white = home, blue = away), 5 per row. */
const CapGrid: React.FC<CapGridProps> = ({ players, side, onPick }) => {
    const sorted = [...players].sort(
        (a, b) => (a.capNumber || a.number) - (b.capNumber || b.number)
    );

    return (
        <div className={`m-capgrid m-capgrid--${side}`}>
            {sorted.map((player) => (
                <button
                    key={player.id ?? player.number}
                    type="button"
                    className="m-capgrid__cap"
                    onClick={(): void => onPick(player)}
                >
                    {player.capNumber || player.number}
                </button>
            ))}
        </div>
    );
};

export default CapGrid;
